import type { LogEntry, SendLogsFn } from './types';

// This is the same as injectorUtils.isNode(), copied here to avoid circular dependency
export function isNode(): boolean {
  return typeof global !== 'undefined' && {}.toString.call(global) === '[object global]';
}

export function createFetchSender(ingestUrl: string, token: string): SendLogsFn {
  return async (logs: LogEntry[]) => {
    await fetch(ingestUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(logs),
    });
  };
}

export function createSuperagentSender(
  ingestUrl: string,
  token: string,
  getProxy?: () => string | undefined
): SendLogsFn {
  const superagent = require("superagent");

  return async (logs: LogEntry[]) => {
    const request = superagent
      .post(ingestUrl)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .send(logs);

    const proxy = getProxy?.();
    if (proxy) {
      (request as unknown as { proxy: (url: string) => void }).proxy(proxy);
    }

    await request;
  };
}
